import React, {createContext, useContext} from 'react';

import {type Account} from './types';

export function safelyParseAccountJson(
  json: string,
  accountList: Account[]
): Account | null {
  try {
    const {id} = JSON.parse(json);
    const matchingAccount = accountList.find(account => account.id === id);
    return matchingAccount != null ? {...matchingAccount, id} : null;
  } catch (e) {
    return null;
  }
}
export enum AccountSelectorStorageKeys {
  ACCOUNT_SELECTOR_VALUE = 'account-selector-value',
  LAST_ACCOUNT_SELECTOR_VALUE = 'last-account-selector-value',
  LAST_NON_IMPERSONATED_ACCOUNT = 'last-non-impersonated-account',
}

type AccountSelectorContextProviderProps = {
  selectedAccount: Account | null;
  setSelectedAccount: (value: Account | null) => void;
  lastNonImpersonatedAccount: Account | null;
  setLastNonImpersonatedAccount: (value: Account | null) => void;
  canSeeOrgInURL: boolean; // Used for individual pages to know whether to redirect to no-access
  accountList: Account[];
  isAccountListLoading: boolean;
};

const initialState = {
  selectedAccount: null,
  setSelectedAccount: () => {},
  lastNonImpersonatedAccount: null,
  setLastNonImpersonatedAccount: () => {},
  canSeeOrgInURL: true,
  accountList: [] as Account[],
  isAccountListLoading: true,
};

export const AccountSelectorContext =
  createContext<AccountSelectorContextProviderProps>(initialState);
AccountSelectorContext.displayName = 'AccountSelectorContext';

export const useAccountSelectorContext = () => {
  const value = useContext(AccountSelectorContext);
  if (value == null) {
    throw new Error(
      'useAccountSelectorContext must be used within a AccountSelectorContextProvider'
    );
  }
  return value;
};
